import landingHome from "./LandingHome";

const AccessControl = {
  ...landingHome,
};

export default AccessControl;
